module.exports = __webpack_public_path__ + "static/img/logo.93d1d9a.png";